<div class="page-header">
    <h2 class="title text-center">
      <span class="text-capitalize">Solicitud De Préstamo</span>
    </h2>
  </div>
  
  <div *ngIf="selectedLoan">
  
    <div class="row mt-3">
  
      <div class="col-md-12">
  
        <h5 class="mb-4">Información Del Colaborador:</h5>
        <app-employee-ref [employeeRef]="selectedLoan.employeeRef"></app-employee-ref>
  
      </div>
  
    </div>
  
    <h5 class="mb-4">Datos de la Solicitud:</h5>
  
    <div class="row">
  
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha de Solicitud del Préstamo:" [value]="selectedLoan.createdAt | date : 'mediumDate'"
            type="text" disabled>
        </mat-form-field>
      </div>
  
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Fecha de Caducidad de la Solicitud:" [value]="expirationDate | date : 'mediumDate'"
            type="text" disabled>
        </mat-form-field>
      </div>
  
    </div>
  
    <div class="row">
  
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Importe del Préstamo:" [value]="selectedLoan.requestedAmount.toFixed(2)" type="text" disabled>
        </mat-form-field>
      </div>
  
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Cuotas de Descuento:" [value]="requestedNumberOfPayments" type="text" disabled>
        </mat-form-field>
      </div>
  
      <div class="col-md-4">
        <mat-form-field>
          <input matInput placeholder="Monto a Descontar {{textWage}} :" [value]="individualPaymentAmount.toFixed(2)" type="number"
            disabled>
        </mat-form-field>
      </div>
  
    </div>
  
    <div *ngIf="selectedLoan.active == false">
  
      <h5 class="mb-4">Razón del Rechazo:</h5>
  
      <mat-form-field>
        <textarea matInput placeholder="Comentario" [value]="selectedLoan.comment" disabled></textarea>
      </mat-form-field>
  
    </div>
  
    <h5 class="mb-4">Últimas Nóminas Pagadas al Colaborador:</h5>
  
    <div class="row">
      <div class="col-md-12">
  
        <mat-table *ngIf="payrollContributions && payrollContributions.length > 0; else noPaymentHistory" [dataSource]="payrollContributions" class="table border">
  
          <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef> Fecha </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.date | UtcPipe }} </mat-cell>
          </ng-container>
  
          <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef> Importe Recibido </mat-header-cell>x
            <mat-cell *matCellDef="let element"> {{element.amount | number: '.2-2'}} </mat-cell>
          </ng-container>
  
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  
        </mat-table>
  
        <ng-template #noPaymentHistory>
  
          <div class="text-center noActions">
            <h5 class="mt-1">No Existe Historial De Pagos De Este Colaborador</h5>
            <mat-icon aria-hidden="true">clear</mat-icon>
          </div>
  
        </ng-template>
  
      </div>
    </div>
  
    <div class="my-5 row">
      <div class="col-md-4" [ngClass]="{'offset-md-8': !selectedLoan.active}">
        <button class="btn btn-outline-secondary btn-block" (click)="onCancel()">Regresar</button>
      </div>
  
      <div class="col-md-4">
        <button class="btn btn-block btn-outline-danger" (click)="setRejectedLoanComment()" *ngIf="selectedLoan.active == true">Rechazar</button>
      </div>
  
      <div class="col-md-4">
        <button class="btn btn-block btn-outline-primary" (click)="approveLoan()" *ngIf="selectedLoan.active == true">Autorizar</button>
      </div>
  
    </div>
  
  </div>
  
  <div *ngIf="!selectedLoan">
    <div class="row mt-4">
      <div class="col-md-12 text-center noActions">
        <mat-icon aria-hidden="true">visibility_off</mat-icon>
        <h5>La solicitud de préstamo no se encuentra en su lista de aprobaciones pendientes.</h5>
      </div>
    </div>
  </div>
  